import React from 'react';
import Icon from '../../Icon/Icon';
import Spinner from '../../Spinner/Spinner';
import Span from '../../Texts/Span/Span';
import * as S from './CellFormatter.styles';

export const IconActionFormatter = ({
  cell,
  row,
  formatExtraData: { action = () => {}, align, icon, label },
}) => {
  const handleOnClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    !cell.disabled && action(row);
  };

  if (cell) {
    return cell.loading ? (
      <Spinner size='sm' variant='primary' />
    ) : (
      <S.Cell
        align={align}
        cursor={cell.disabled ? 'default' : 'pointer'}
        onClick={handleOnClick}
      >
        <Icon
          alt=''
          name={icon.name}
          width={icon?.width}
          height={icon?.height}
          variant={cell.disabled ? 'neutral' : 'primary'}
          cursor={cell.disabled ? 'default' : 'pointer'}
          disabled={cell?.disabled}
        />
        {label && (
          <Span
            type='2'
            variant={cell.disabled ? 'neutral' : 'primary'}
            modifier={cell.disabled ? 'weak' : 'regular'}
          >
            {label}
          </Span>
        )}
      </S.Cell>
    );
  } else return null;
};
